export default "__VITE_ASSET__D5Ue8bU4__"